import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import * as noUiSlider from 'nouislider'

const localEventBus = new Vue();

@Component({
    template: `<div ref="slider"></div>`
})
export default class SingleSlider extends Vue {
    @Prop() tunniste: string; // Pakollinen. Tällä tunnistetaan, mille sliderille eventit menevät.
    @Prop() rangeValues: Array<number>;
    @Prop() value: number; // v-model. Tämän arvoa ei saa vaihtaa suoraan, vaan jos täällä slider-komponentissa täytyy muuttaa arvoa, niin se tapahtuu
                          // this.$emit('input', Muutettu_arvo)  -kutsun kautta.
    @Prop() dontResetIfZero: boolean; // joitain slidereita ei haluta resetoida vaikka arvo olisi 0.
    @Prop() disabled: boolean;
    selectedIndex = 0;
    $refs: {
        slider: HTMLFormElement;
    }

    @Watch('value', { immediate: true })
    valueChanged(val: number) {
        // Resetoidaan sliderin täppä, jos v-model on 0
        if (val === 0) {
            localEventBus.$emit('paivita', val.toString(), this.tunniste)
        }
    }

    @Watch('disabled', { immediate: true })
    toggelDisable(val: boolean) {
        if (val && this.$refs.slider != null) {
            this.$refs.slider.setAttribute('disabled', 'true');
        }

        else if (this.$refs.slider != null){
            this.$refs.slider.removeAttribute('disabled');
        }
    }

    @Watch('rangeValues', { immediate: true })
    rangeChanged(val: Array<number>) {
        // Päivitetään sliderin rangea, jos rangeValues muuttuu
        if (val.length > 0 && this.$refs.slider !== null) {
            this.$refs.slider.noUiSlider.updateOptions({
                range: {
                    'min': 0,
                    'max': val.length - 1
                }
            });
        }
    }

    @Watch('rangeValues') 
    onPropertyChanged(value: any, oldValue: any) {
            if (value.length != oldValue.length) {
                let self = this;
                let max = this.rangeValues.length - 1;
                if (max < 1) max = 1;
                this.$refs.slider.noUiSlider.destroy();
                this.selectedIndex = this.rangeValues.indexOf(this.value);
                if (this.selectedIndex < 0) this.selectedIndex = 0;

                noUiSlider.create(this.$refs.slider, {
                    start: this.selectedIndex,
                    connect: [true, false],
                    step: 1,
                    animate: true,
                    range: {
                        min: 0,
                        max: max
                    }
                });

                this.$refs.slider.noUiSlider.on('update', (val_str: string) => {
                    localEventBus.$emit('paivita', val_str, self.tunniste)
                })
            }     
        }

    created() {
        const self = this;
        localEventBus.$on('paivita', (payload: string, tunniste: string) => {
            if (tunniste !== self.tunniste) return; // Ei ole tämän sliderin event.

            const val = parseFloat(payload[0]);
            if (val === self.selectedIndex) return; // Ei muutosta
            self.selectedIndex = val;
            
            if (self.selectedIndex === 0 && self.$refs.slider !== null && !self.dontResetIfZero) {
                self.$refs.slider.noUiSlider.reset();
            }
            self.$emit('input', self.rangeValues[val]);   // value-propertyn arvo vaihdetaan tämän komponentin ulkopuolele
            self.$emit('slider-changed');
        })
    }

    mounted() {
        let self = this;
        let max = this.rangeValues.length - 1;
        if (max < 1) max = 1;

        this.selectedIndex = this.rangeValues.indexOf(this.value);
        if (this.selectedIndex < 0) this.selectedIndex = 0;

        noUiSlider.create(this.$refs.slider, {
            start: this.selectedIndex,
            connect: [true, false],
            step: 1,
            animate: true,
            range: {
                min: 0,
                max: max
            }
        });

        this.$refs.slider.noUiSlider.on('update', (valStr: string) => {
            localEventBus.$emit('paivita', valStr, self.tunniste)
        })
    }

}

